import { UseQueryOptions } from '@tanstack/react-query';

import { SMS } from 'domains/content/types';
import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';

import QueryKeys from './keys';

/**
 * Hook to fetch all SMS content
 *
 * @param reactQueryOptions Additional react-query options
 * @param axiosOptions Options for axios request (e.g., params for query string)
 * @returns Query result with array of SMS content items
 */
const useSmses = (
    reactQueryOptions?: UseQueryOptions<SMS[], Error>,
    axiosOptions?: { params?: { status?: string } }
) => {
    // Always filter by status=published,live
    const mergedAxiosOptions = {
        ...axiosOptions,
        params: {
            ...axiosOptions?.params,
            status: 'published,live',
        },
    };

    // Poll the SMS list every 10s. The CustomCampaign wizard mounts SmsContentStep once on
    // entry and the dropdown options are derived from this query result, so a template
    // created externally (another tab, an API call, a test prereq mid-scenario) would
    // never show up without a refetch. The list is small (~600 rows) and SMS content
    // creation/edit is not in the hot path, so 10s polling is a negligible cost.
    const mergedReactQueryOptions = {
        refetchInterval: 10_000,
        ...reactQueryOptions,
    };

    return useQuery<SMS[]>(QueryKeys.SMSES, CuredApiPaths.SMS, mergedReactQueryOptions, mergedAxiosOptions);
};

export default useSmses;
